import ImageFileInput from 'shared/components/molecules/ImageFileInput/ImageFileInput';
export * from './validation';

export default ImageFileInput;
